module.exports = __webpack_public_path__ + "static/media/tyre-red-four3.bb123ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-four3.png
// module id = 341
// module chunks = 0